<template>
    <div class="screen">
        <div class="screen__header"
             v-if="!title">
            <h1>Generator Generator</h1>
            <h2>Make your own generator</h2>
            <p class="screen__byline">
                <em>By <a href="http://haykranen.nl/?ref=gengen">Hay Kranen</a></em>
            </p>
        </div>

        <div class="screen__header"
             v-if="title">
            <h1>{{title}}</h1>
            <p class="screen__byline">
                <em>
                    Generated with Hay Kranen's <a href="https://projects.haykranen.nl/gengen/">Generator Generator</a>
                </em>
            </p>
        </div>

        <div>
            <section
                v-if="output"
                class="screen__output">
                <ul v-if="showAsList"
                    class="screen__list">
                    <li
                        v-for="(el, index) in output"
                        v-bind:key="index">{{el}}</li>
                </ul>

                <p v-if="!showAsList"
                   class="screen__generated">{{join(output)}}</p>
            </section>

            <button
                class="button margin-center"
                v-on:click="generate">Generate</button>

            <hr class="hr" />

            <label for="as-list" class="text-center mw db mt-1">
                <input
                    type="checkbox"
                    v-model="showAsList"
                    id="as-list" />

                Show as list
            </label>
        </div>

        <button
            class="button margin-center"
            v-on:click="toggleEdit">
            <span v-show="isEdit">Done editing</span>
            <span v-show="!isEdit">Edit generator</span>
        </button>

        <button
            v-on:click="reset"
            class="button button--link margin-center">Reset data</button>

        <div
            v-show="isEdit"
            class="screen__model">
            <button
                class="button margin-center"
                v-on:click="save">Save model</button>

            <p class="text-center mt-2 db">Title for your generator (optional)</p>

            <input v-model="title"
                   class="screen__input" />

            <p class="text-center mt-2 mb-2 db">Edit your lists here. Separate entries by newline.</p>

            <section
                v-for="(list, index) in lists"
                v-bind:key="index">
                <h2 class="screen__model-title">
                    List {{index + 1}}

                    <button
                        class="text-link"
                        v-on:click="removeList(index)">🗑 remove</button>
                </h2>

                <textarea
                    class="screen__textarea mw"
                    v-model="list.text"></textarea>
            </section>

            <button
                class="button margin-center"
                v-on:click="addList">Add list</button>
        </div>

        <p class="text-center text-muted mt-2">
            Like this tool? Consider <a class="text-muted text-link" href="https://www.haykranen.nl/donate/">supporting my work</a>.
        </p>
    </div>
</template>

<script>
    import { sample } from 'donot';
    import { DataSilo } from '../datasilo.js';
    import defaultData from '../default-data.js';

    // Probably shouldn't be hardcoded here i guess
    const datasilo = new DataSilo('https://projects.haykranen.nl/datasilo/', 'gengen');

    export default {
        data() {
            return {
                isEdit : false,
                hasTitle : false,
                lists : [],
                output : '',
                showAsList : false,
                title : ''
            }
        },

        methods : {
            addList() {
                this.lists.push({ text : '' });
            },

            generate() {
                // Separate lists by newline
                const lists = this.lists.map((list) => {
                    list = list.text.trim().split('\n').map(l => l.trim()).filter(l => !!l);
                    return list;
                });

                this.output = lists.map(sample);
            },

            join(arr) {
                return arr. join(' ');
            },

            async loadState() {
                if (!window.location.hash) {
                    this.lists = defaultData.lists;
                    return;
                }

                const uid = window.location.hash.slice(1);
                let data;

                try {
                    data = await datasilo.get(uid);
                } catch (e) {
                    console.error(e);
                    this.lists = defaultData.lists;
                    return;
                }

                if (!data) {
                    throw new Error('Invalid data');
                }

                this.lists = data.lists;
                this.title = data.title || '';
            },

            removeList(removeIndex) {
                const confirm = window.confirm(`Are you sure you want to delete list ${removeIndex + 1}?`);

                if (!confirm) {
                    return;
                }

                this.lists = this.lists.filter((list, index) => index !== removeIndex);
            },

            reset() {
                const isReset = window.confirm('Sure? This will reset the generator and all data');

                if (isReset) {
                    window.location.hash = '';
                    window.location.reload();
                }
            },

            async save() {
                const state = {
                    lists : this.lists,
                    title : this.title
                };

                const uid = await datasilo.post(state);

                if (uid) {
                    window.location.hash = uid;
                }
            },

            toggleEdit() {
                this.isEdit = !this.isEdit;
            }
        },

        async mounted() {
            window.addEventListener('hashchange', this.loadState.bind(this));
            await this.loadState();
            this.generate();
        }
    }
</script>